module.exports = __webpack_public_path__ + "src/assets/img/share/tips/extroversion/1b04526db95eb8e13392b300a7ce2db6.png";